// extracted by mini-css-extract-plugin
export default {"emptyContainer":"EmptyTable_emptyContainer__TCnNQ","emptyCATBtn":"EmptyTable_emptyCATBtn__r+5hC"};